export default __webpack_public_path__ + "static/media/mouse.6ed6e892.png";